import { UrlService } from './url/url.service';
import { WebsocketService } from './websocket/websocket.service';
import { PreviewsService } from './previews/previews.service';
import { WindowService } from './window.service';
import { TitleService } from './title.service';
import { BrowserService } from './browser.service';
import { InterfaceListenerService } from './interface-listener/interface-listener.service';
import { ThreeDotService } from './three-dot/three-dot.service'
import { CoreResizeDetectorService } from './resize-detector.service';


export const CoreServicesProvider = [
    UrlService,
    WebsocketService,
    PreviewsService,
    WindowService,
    TitleService,
    BrowserService,
    InterfaceListenerService,
    ThreeDotService,
    CoreResizeDetectorService

];
